'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _basicTextPage = require('./basic-text-page');

var _basicTextPage2 = _interopRequireDefault(_basicTextPage);

var _reactIntl = require('react-intl');

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale = 'en';

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;
try {
	messages = require('../lang/' + localeBase + '.json');
} catch (error) {
	messages = require('../../src/lang/en.json');
}

(0, _reactIntl.addLocaleData)(lang);

var Career = function Career() {
	return _react2.default.createElement(
		_reactIntl.IntlProvider,
		{ locale: localeBase, messages: messages },
		_react2.default.createElement(
			_basicTextPage2.default,
			{
				pageTitle: 'Careers | Doctify',
				pageDescription: 'Available jobs at Doctify. Rate, review and book doctors and specialists online',
				pagePath: (0, _doctifyUtils.getResourcePath)('/career')
			},
			_react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'Careers'
				),
				_react2.default.createElement(
					'p',
					null,
					'Coming soon.'
				)
			)
		)
	);
};

Career.displayName = 'Career';

Career.defaultProps = {};

exports.default = Career;


// WEBPACK FOOTER //
// ./components/info-page/lib/components/career-page.js